import { render, staticRenderFns } from "./ListDividedItem.vue?vue&type=template&id=62b453be&scoped=true&"
import script from "./ListDividedItem.vue?vue&type=script&lang=ts&"
export * from "./ListDividedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListDividedItem.vue?vue&type=style&index=0&id=62b453be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b453be",
  null
  
)

export default component.exports